import { post } from './axios'
import constants from '../utils/constants'
import JUDITE_API_ROUTES from '../routes/judite-api-routes'

const emitCallEvent = async (username, value) => {
  try {
    await post(
      `${constants.JUDITE_API_ENDPOINT}${JUDITE_API_ROUTES.CALL}`,
      {
        username,
        value,
      },
    )

    return true
  } catch (error) {
    return false
  }
}

export { emitCallEvent }
